import { ApolloError, ApolloQueryResult, useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import {
  GetDisplayDetailsQueryQuery,
  GetDisplayDetailsQueryQueryVariables,
} from './__generated__/useDisplayDetails.generated';

type GetDisplayDetailsQuery_getUnauthorizedArrivalDisplayDetails = NonNullable<
  GetDisplayDetailsQueryQuery['getUnauthorizedArrivalDisplayDetails']
>;

const DISPLAY_DETAILS_QUERY = gql`
  query GetDisplayDetailsQuery(
    $organizationId: ID!
    $registrationKey: ArrivalDisplayRegistrationKey!
  ) {
    getUnauthorizedArrivalDisplayDetails(
      orgId: $organizationId
      registrationCode: $registrationKey
    ) {
      id
      name
      location {
        id
        name
      }
      organization {
        id
        name
        logo
      }
    }
  }
`;

type UseDisplayDetails = {
  details:
    | GetDisplayDetailsQuery_getUnauthorizedArrivalDisplayDetails
    | null
    | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (
    variables?: Partial<GetDisplayDetailsQueryQueryVariables> | undefined
  ) => Promise<ApolloQueryResult<GetDisplayDetailsQueryQuery>>;
};

export const useDisplayDetails = (
  organizationId: string,
  registrationKey: string
): UseDisplayDetails => {
  const { data, error, loading, called, refetch } = useQuery<
    GetDisplayDetailsQueryQuery,
    GetDisplayDetailsQueryQueryVariables
  >(DISPLAY_DETAILS_QUERY, {
    variables: {
      organizationId,
      registrationKey,
    },
  });

  return {
    details: data?.getUnauthorizedArrivalDisplayDetails,
    loading: !called || loading,
    error,
    refetch,
  };
};
